import React from 'react';
import { SelectInput } from 'react-admin';

const BillingFrequencyInput = props => (
    <SelectInput
        source="billing_frequency"
        label="Billing Frequency"
        choices={[
            { id: 'oneshot', name: 'One-shot (facturation unique)' },
            { id: 'monthly', name: 'Monthly (facturation mensuelle)' },
        ]}
        defaultValue="oneshot"
        {...props}
    />
);

export default BillingFrequencyInput;
